import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

export const getDashCount = createAsyncThunk(
  "dashboard/getDashCount",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/dashboard-count");
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || err || "Something went wrong",
      );
    }
  },
);
